import React, { useEffect } from 'react';
import Sidemenu from '../components/base/sidemenu';
import Dashboard from '../components/dashboard/dashboard';

export default function DashboardPage() {
  
  return (
    <div className='flex'>
      <Sidemenu />
      <Dashboard />
    </div>
  );
}